module.exports = __webpack_public_path__ + "static/img/pwd@2x.63e7e4ca.png";